import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { useField } from '@unform/core';
import { IconBaseProps } from 'react-icons';
import { GoSearch } from 'react-icons/go';

import { Container } from './styles';

type Filter = {
  id: number;
  value: any;
  label: string;
};

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: React.CSSProperties;
  filters?: Filter[];
  onFilterChange?: (filter: string) => void;
}

export interface SearchFieldHandles {
  getFilter(): string;
}

const Input: React.ForwardRefRenderFunction<SearchFieldHandles, InputProps> = (
  { name, icon: Icon, containerStyle, filters, onFilterChange, ...rest },
  ref,
) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [filter, setFilter] = useState(filters ? filters[0].value : 'grupo');
  const { fieldName, defaultValue, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);

    setIsFilled(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const getFilter = useCallback(() => filter, [filter]);

  useImperativeHandle(ref, () => ({
    getFilter,
  }));

  return (
    <Container isFocused={isFocused} isFilled={isFilled} style={containerStyle}>
      {Icon && <Icon size={20} />}
      <input
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />

      <select
        name="option"
        defaultValue={filter}
        onChange={(event) => {
          setFilter(event.target.value);
          onFilterChange?.(event.target.value);
        }}
      >
        {filters ? (
          filters.map((currentFilter) => (
            <option key={currentFilter.id} value={currentFilter.value}>
              {currentFilter.label}
            </option>
          ))
        ) : (
          <>
            <option value="grupo">Grupo</option>
            <option value="produto" disabled>
              Produto
            </option>
          </>
        )}
      </select>

      <button type="submit">
        <GoSearch />
      </button>
    </Container>
  );
};

export default forwardRef(Input);
